import React from "react";
import MobileButton from "../MobileButton/mobileButton";
import {createPortal} from "react-dom";
import {useDetailsSheetContext} from "../../context/detailsSheetContext";
import {isStateClosed, isStateMenuOpen, isStateShopsOpen} from "../../context/utils";
import MobileMenu from "../MobileButton/mobileMenu";
import './style.css';
import {useUiContext} from "../../context/uiContext";

const MobileButtonContainer = () => {
    const mount = document.getElementById('js--mobile-button-container');

    const [{isMobile}] = useUiContext();

    const [{mobileDisplayState},
        {setStateMenuOpen, setStateClosed, setStateShopsOpen}] = useDetailsSheetContext();

    if (!mount || !isMobile) return null;

    return createPortal(
        <>

            { isStateClosed(mobileDisplayState) &&
                <MobileButton clickHandler={()=>{ setStateMenuOpen() }} />}

            { isStateMenuOpen(mobileDisplayState) &&
                <MobileMenu closeHandler={setStateClosed} displayShopsHandler={setStateShopsOpen}  />}
        </>, mount);
}

export default MobileButtonContainer;